import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';

const { Title, Text } = Typography;

export default function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  async function onFinish(values: { identifier: string; password: string }) {
    setLoading(true);
    try {
      const { identifier, password } = values;
      const isIin = /^\d{12}$/.test(identifier.trim());
      const isPhone = identifier.trim().startsWith('+');
      const body = isIin
        ? { iin: identifier.trim(), password }
        : isPhone
        ? { phone: identifier.trim(), password }
        : { email: identifier.trim(), password };

      const { data } = await api.post('/auth/login', body);
      const token = data.access_token;
      localStorage.setItem('admin_token', token);

      const me = await api.get('/auth/me', {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (me.data.role !== 'admin') {
        localStorage.removeItem('admin_token');
        message.error('Доступ только для администраторов');
        return;
      }

      navigate('/dashboard');
    } catch (err: any) {
      message.error(err.response?.data?.detail || 'Неверные данные');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: '#f0f2f5',
      padding: 16,
    }}>
      <Card style={{
        width: '100%',
        maxWidth: 380,
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>💊</div>
          <Title level={3} style={{ margin: 0 }}>Мои рецепты</Title>
          <Text type="secondary">Панель администратора</Text>
        </div>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="identifier"
            rules={[{ required: true, message: 'Введите ИИН, телефон или email' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="ИИН (12 цифр), телефон или email"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Введите пароль' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Пароль"
              size="large"
            />
          </Form.Item>

          <Button type="primary" htmlType="submit" block size="large" loading={loading}>
            Войти
          </Button>
        </Form>
      </Card>
    </div>
  );
}
